import { Injectable } from '@angular/core';
import { StorageService } from '@shared';

@Injectable()
export class RxdbIdProvider {
	public constructor(private storageService: StorageService) {}

	public async setRxdbId(workspaceId: string, rxdbId: number): Promise<void> {
		await this.storageService.set(this.buildKey(workspaceId), rxdbId);
	}

	public async getCurrentRxdbId(workspaceId: string): Promise<number> {
		return await this.storageService.get(this.buildKey(workspaceId));
	}

	public buildKey(workspaceId: string): string {
		return 'rxdbId_' + workspaceId;
	}
}
